import { MAIN_PROFILE_EDIT_MODE } from "../../../../../shared/data-cy";
import { AVAILABILITY } from "../../constants";

// eslint-disable-next-line import/prefer-default-export
export const BASE_PATH = `${MAIN_PROFILE_EDIT_MODE}_${AVAILABILITY}`;
